export default "__VITE_ASSET__BtK8SHM6__"